<template>
  <div class="main">
    <div class="collapse" :class="{'collapse-close': isopen?false:true}" @click="handlecollapse">
      <img :src="require(isopen?'../../assets/images/open.png':'../../assets/images/close.png')" alt="">
    </div>
    <div class="left" :class="{'hidden': isopen?false:true}">
      <div class="search">
        <el-select v-model="professionId" placeholder="请选择" style="width: 172px" @change="selectData">
          <el-option
            v-for="item in professionData"
            :key="item.id"
            :label="item.dictionaryName"
            :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="teachStatus" placeholder="请选择" style="width: 100px" @change="getTableData">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> 
      </div>
      <ul class="list">
        <li @click.stop="chooseItem(val)" v-for="val in dirctoryList" :key="val.id" :class="{'active': directoryId==val.id}">
          <!-- <div></div> -->
          <span class="index">{{val.levelPath}}</span>
          <span class="title">{{val.name}}</span>
        </li>
      </ul>
    </div>
    <div class="right" :class="{'set-width': isopen?false:true}">
      <div v-if="!isempty">
        <div v-if="directoryId">
          <div class="title">
            <i class="border"></i>
            <p class="p">{{directoryName}}</p>
            <span>此数据为全平台数据，每日凌晨更新～</span>
          </div>
          <ul class="num-list">
            <li class="big-li">
              <span>{{chapterAnalyse.totalNum}}</span>
              <p>本章小节数量</p>
            </li>
            <li>
              <span>{{chapterAnalyse.mustNum}}</span>
              <p>必学小节数量</p>
            </li>
            <li>
              <span>{{chapterAnalyse.undoNum}}</span>
              <p>选学小节数量</p>
            </li>
            <li>
              <span>{{chapterAnalyse.noContentNum}}</span>
              <p>无内容小节数量</p>
            </li>
          </ul>
          <div class="content">
            <div class="form">
              <img class="search" src="../../assets/images/search.png" alt="">
              <el-input class="input" v-model="search.name" placeholder="搜索小节序号或名称" style="width: 328px;"></el-input>
              <button @click="handleSearch">搜索</button>
            </div>
            <div class="table-data" v-if="tableData.length">
              <div v-for="item in tableData" class="table-div">
                <el-table
                  :header-cell-style="{background:'#ECF3FF', color:'#4F6389'}"
                  class="table-box" border
                  ref="filterTable" :span-method="objectSpanMethod"
                  :data="item.list"
                  style="width: 100%">
                  <el-table-column prop="name" label="小节名称">
                    <template slot-scope="{ row }">
                      <div class="name">{{row.levelPath}}{{row.name}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalNum" label="已分配人数" width="170px" align="center"></el-table-column>
                  <el-table-column label="类型">
                    <template slot-scope="{ row }">
                      <div class="type">
                        <span>{{row.type==1?'视频题':row.type==2?'理论题':'病例题'}}</span>
                        <span :class="row.task?'bi':'xuan'">{{row.task?'必':'选'}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="amount2" label="已学完人数" align="center">
                    <template slot-scope="{ row }">
                      <div class="circle-progress-container">
                        <div class="progress-container">
                          <div class="progress" :style="{ '--progress': (row.number/row.totalNum) * 100 + '%' }"></div>
                        </div>
                        <span class="progress-text">{{row.number}}人</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="amount3" label="掌握情况" width="364px" align="center">
                    <template slot-scope="{ row }">
                      <div class="rate" v-if="row.type==1" style="text-align:center">/</div>
                      <div class="rate" v-if="row.type==2">
                        <div class="progress">
                          <div class="bar">
                            <div :style="`width: ${row.rate/100 * 100}%`" class="bar-1"></div>
                          </div>
                        </div>
                        <span class="green">{{row.rate}}%</span>
                      </div>
                      <div class="rate" v-if="row.type==3">
                        <div class="progress">
                          <div class="bar">
                            <div :style="`width: ${row.findrate/100 * 100}%`" class="bar-1"></div>
                          </div>
                        </div>
                        <span class="green">{{row.findrate||0}}%（影像学表现）</span>
                        <div class="progress">
                          <div class="bar">
                            <div :style="`width: ${row.rate/100 * 100}%`" class="bar-1"></div>
                          </div>
                        </div>
                        <span class="green">{{row.rate||0}}%（诊断）</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="128px" align="center"> 
                    <template slot-scope="{ row }">
                      <span class="look" @click="handleLook(row)">查看详情 <i class="el-icon-arrow-right"></i></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="table-empty" v-if="!tableData.length" style="height:calc(100vh - 338px)">
              <div class="box">
                <img src="../../assets/images/empty.png" alt="">
                <p>暂无数据~</p>
              </div>
            </div>
          </div>
        </div>
        <div class="empty" v-else>
          <img src="../../assets/images/empty.png" alt="">
          <p>请先选择需要分析的章节</p>
        </div>
      </div>
      <div class="empty" v-if="isempty">
        <img src="../../assets/images/empty.png" alt="">
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import { analysisServer, keyServer } from '@/api/api'
export default {
  data () {
    return {
      isempty: true,
      isopen: true,
      currentcourse: {},
      dirctoryList: [],
      professionData: [],
      professionId: '',
      options: [
        { name: '全部', id: 0 },
        { name: '在教中', id: 1 },
        { name: '已结课', id: 2 }
      ],
      teachStatus: 1,
      directoryId: '',
      search: {
        name: ''
      },
      chapterAnalyse: {},
      tableData: [],
      // 存储每一行的合并行数
      mergeData: []
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      try {
        await this.selectDataV1();
        this.selectData();
      } catch (error) {
        console.error('数据初始化失败:', error);
      }
    },
    selectData () {
      return new Promise((resolve, reject) => {
        analysisServer.queryDirctoryList({
          // professionId: 'aed39b00-614e-11f0-9791-005056952c99',
          professionId: this.professionId,
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.dirctoryList = data
            this.directoryId = data[0].id
            this.directoryName = data[0].name
            this.getTableData()
          } else {
            this.$message.error(message)
          }
          resolve(res)
        }).catch((error) => {
          this.$message.error(error)
        })
      })
    },
    // 专业数据
    selectDataV1 () {
      return new Promise((resolve, reject) => {
        keyServer.profession({
          dictionaryKey: 'profession'
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.professionData = data
            this.professionId = this.professionData[0].id
            resolve();
          } else {
            this.$message.error(message)
            reject(new Error(message));
          }
        }).catch((error) => {
          this.$message.error(error)
          reject(error);
        })
      });
    },
    getTableData () {
      analysisServer.queryDirctoryInfo({
        // professionId: 'aed39b00-614e-11f0-9791-005056952c99',
        professionId: this.professionId,
        // directoryId: 126,
        directoryId: this.directoryId,
        status: this.teachStatus,
        ...this.search
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          console.log(data, '-===')
          if (data && data.chapterAnalyse) {
            this.isempty = false
            this.chapterAnalyse = data.chapterAnalyse
            if (data.chapterInfoM) {
              this.tableData = data.chapterInfoM
              this.initTableData()
            } else {
              this.tableData = []
            }
            return
          }
          this.isempty = true
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    }, 
    chooseItem (item) {
      this.currentcourse = item
      this.directoryId = item.id
      this.directoryName= item.name
      this.search.name = ''
      this.getTableData()
    },
    initTableData () {
      this.tableData.forEach(val => {
        let list = [
          {id: val.id, directoryId: val.directoryId, totalNum: val.totalNum, name: val.name, levelPath: val.levelPath, type: 1, number: val.videoNum, task: val.videoTask, status: val.videoStatus},
          {id: val.id, directoryId: val.directoryId, totalNum: val.totalNum, name: val.name, levelPath: val.levelPath, type: 2, number: val.questionNum, task: val.questionTask, status: val.questionStatus, rate: val.questionCorrectRate},
          {id: val.id, directoryId: val.directoryId, totalNum: val.totalNum, name: val.name, levelPath: val.levelPath, type: 3, number: val.studyNum, task: val.studyTask, status: val.studyStatus, rate: val.studyCorrectRate, findrate: val.studyFindCorrectRate},
        ]
        this.$set(val, 'list', list)
      })
      console.log(this.tableData, '000')
      // 初始化时生成合并信息
      // 初始化时生成合并信息
      this.tableData.forEach(val => {
        if (val.list && val.list.length) {
          this.calculateMergeData(val.list);
        }
      });
    },
    handleSearch () {
      this.getTableData()
    },
    handleLook (row) {
      let params = {
        professionId: this.professionId,
        directoryName: this.directoryName,
        status: this.teachStatus,
        rowInfo: row
      }
      let rourteUrl = this.$router.resolve({
        path: 'analysisdetail',
        query: {
          params: JSON.stringify(params)
        }
      });
      window.open(rourteUrl.href, '_blank')
      // this.$router.push({
      //   path: 'analysisdetail',
      //   query: {
      //     params: JSON.stringify(params)
      //   }
      // })
    },
    /**
     * 计算合并所需的数据
     * @param {Array} data 表格数据
     */
    calculateMergeData(data) {
      this.mergeData = [];
      if (!data.length) return;
      // 假设整个表格数据合并成一行
      const count = data.length; 
      for (let i = 0; i < count; i++) {
        this.mergeData.push({
          rowspan: i === 0 ? count : 0, // 仅第一行有 rowspan，其余行设为 0
          colspan: 1,
        });
      }
    },
    /**
     * 表格合并方法
     * @param {Object} param 包含行、列、索引等信息
     * @returns {Object} 合并配置 {rowspan, colspan}
     */
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只对前三列进行合并
      if (columnIndex < 2) {
        return this.mergeData[rowIndex] || { rowspan: 1, colspan: 1 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    handlecollapse () {
      this.isopen = !this.isopen
    },
  }
}
</script>
<style lang='scss' scoped>
.main {
  height: calc(100vh - 70px);
  display: flex;
  padding-left: 10px;
  .collapse {
    width: 20px;
    height: 100px;
    position: absolute;
    left: 312px;
    top: 35%;
    cursor: pointer;
    img {
      width: 20px;
      height: 100px;
    }
  }
  .collapse-close {
    left: 10px;
    transform: all 1s;
  }
  .left {
    padding: 16px;
    width: 312px;
    height: 100%;
    border-radius: 16px 0px 0px 16px;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 8px 24px 0px rgba(132, 157, 213, 0.2);
    .search {
      display: flex;
      justify-content: space-between;
      /deep/ .el-input__suffix {
        color: #4F6389;
        .el-input__icon{
          line-height: 32px !important;
        }
      }
      /deep/ .el-input__inner{
        border: 1px solid #D0DFFB;
        color: #4F6389;
        height: 32px;
        line-height: 32px;
      }
      /deep/ .el-select .el-input .el-select__caret{
        color: #4F6389;
      }
    }
    .list {
      list-style: none;
      margin-top: 8px;
      height: calc(100% - 40px);
      overflow: auto;
      padding-right: 8px;
      margin-right: -8px;
      li {
        padding: 16px 8px;
        border-radius: 8px;
        text-align: left;
        font-size: 16px;
        cursor: pointer;
        display: flex;
        span {
          display: inline-block;
          color: #4B4B4B;
        }
        .index {
          // width: 24px;
          // height: 24px;
          // line-height: 24px;
          padding: 4px 8px;
          border-radius: 4px;
          text-align: center;
          color: #0052D9;
          background: #C4DAFD;
          align-self: baseline;
        }
        .title {
          margin-left: 8px;
          line-height: 26px;
          // width: calc(100% - 38px);
        }
        &:hover, &.active {
          .index {
            background: #0052D9;
            color: #FFFFFF;
          }
          .title {
            color: #0052D9;
          }
        }
        &.active {
          background: #E2ECFC;
        }
      }
    }
  }
  .hidden {
    display: none;
  }
  .right {
    padding: 22px 16px;
    width: calc(100% - 313px);
    height: 100%;
    overflow: auto;
    border-radius: 0px 16px 16px 0px;
    background: rgba(255, 255, 255, 0.8);
    text-align: left;
    margin-left: 1px;
    position: relative;
    .empty {
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      img {
        width: 264px;
        height: 208px;
      }
      p {
        font-size: 16px;
        color: #8DA0C2;
      }
    }
    .title {
      display: flex;
      align-items: center;
      .border {
        display: inline-block;
        width: 4px;
        height: 16px;
        border-radius: 40px;
        background: #3176FF;
        margin-right: 8px;
        vertical-align: inherit;
      }
      p {
        color: rgba(0, 0, 0, 0.9);
        font-size: 18px;
        font-family: "AlimamaShuHeiTi";
        line-height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: calc(100% - 268px);
      }
      span {
        font-family: Avenir,Helvetica,Arial,sans-serif;
        font-size: 14px;
        color: #4F6389;
        margin-left: 8px;
        vertical-align: middle;
      }
    }
    .num-list {
      list-style: none;
      height: 88px;
      margin-top: 18px;
      padding: 16px 32px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: inset -4px 4px 24px 0px #FFFFFF;
      border-radius: 16px 16px 0px 0px;
      li {
        color: #4F6389;
        text-align: center;
        display: inline-block;
        margin-right: 64px;
        height: 56px;
        span {
          font-weight: 600;
          font-size: 28px;
          display: block;
        }
        p {
          font-size: 16px;
          margin-top: 4px;
        }
      }
      .big-li {
        position: relative;
        &::after {
          display: block;
          content: '';
          position: absolute;
          right: -33px;
          top: 0;
          bottom: 0;
          width: 1px;
          background: #EBEEF5;
        }
      }
    }
    .content {
      width: 100%;
      height: calc(100% - 116px);
      padding: 16px;
      border-radius: 0px 0px 16px 16px;
      background: #FFFFFF;
      .form {
        margin-bottom: 16px;
        position: relative;
        .search {
          width: 24px;
          height: 24px;
          position: absolute;
          left: 8px;
          top: 8px;
          z-index: 10;
        }
        button {
          height: 37px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #D0DFFB;
          padding: 5px 16px;
          color: #6097FF;
          font-size: 14px;
          &:hover {
            
            border-color: #2B5EEF !important;
            background: #2B5EEF !important;
            color: #fff !important;
          }
        }
      }
      .table-div {
        margin-bottom: 16px;
      }
      .table-div:last-of-type {
        margin-bottom: 0;
      }
      .table-box {
        overflow: auto;
        border-radius: 4px;
        color: #4B4B4B;
        font-size: 16px;
        .name {
          font-weight:600;
          max-height: 300px;
          overflow: auto;
          line-height: 28px;
        }
        .type {
          height: 100px;
          line-height: 100px;
          span {
            color: #4B4B4B;
            font-size: 16px;
          }
          span.bi, span.xuan {
            font-family: "AlimamaShuHeiTi";
            display: inline-block;
            font-size: 12px;
            width: 34px;
            height: 20px;
            line-height: 18px;
            text-align: center;
            border-radius: 60px;
            margin-left: 8px;
          }
          .bi {
            background: #FFEED6;
            border: 1px solid #FFA424;
            color: #FFA424;
          }
          .xuan {
            background: #E1EAFF;
            border: 1px solid #7AA3FF;
            color: #7AA3FF;
          }
        }
        .circle-progress-container {
          position: relative;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 40px;
          line-height: 40px;
          margin: 0 auto;
          position: relative;
          .progress-container {
            position: relative; /* 修改为相对定位 */
            display: inline-block;
            width: 40px;
            height: 40px;
            margin: 0; /* 移除左侧外边距 */
            vertical-align: middle;
            .progress {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              background: conic-gradient(#3176FF var(--progress), rgba(54, 110, 244, 0.3) 0deg);
              position: relative;
              &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 58%;
                height: 58%;
                border-radius: 50%;
                background-color: #f5f8fd;
              }
            }
          }
          .progress-text {
            position: relative; /* 修改为相对定位 */
            display: inline-block;
            text-align: center;
            margin: 0 0 0 8px; /* 调整外边距 */
            color: #003CAB;
            font-size: 16px;
          }
        }
        .rate {
          color: #3D3D3D;
          text-align: left;
          .green {
            color: #358C05;
          }
          .progress{
            width: 160px;
            display: inline-block;
            height: 8px;
            margin-right: 8px;
            .label {
              display: inline-block;
              font-family: PingFang SC;
              font-size: 36px;
              line-height: 44px;
              font-weight: 600;
              color: #FFC81A;
              width: 250px;
              .num {
                display: inline-block;
                margin: 0 5px;
              }
            }
            .bar{
              display: inline-block;
              width: 100%;
              height: 8px;
              border-radius: 80px;
              background: rgba(67, 150, 19, 0.2);
              position: relative;
              .bar-1{
                transition: width 1s;
                position: absolute;
                background: #4EBB11;
                border-radius: 80px;
                height: 8px;
                left: 0;
              }
            }
          }
        }
        .look {
          font-size: 14px;
          color: #0052D9;
          cursor: pointer;
        }
      }
      .table-empty {
        text-align: center;
        position: relative;
        .box {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        img {
          width: 196px;
          height: 154px;
        }
        p {
          font-size: 16px;
          color: #8DA0C2;
        }
      }
      .table-data {
        height: calc(100vh - 338px);
        overflow: auto;
        padding-right: 8px;
        margin-right: -8px;
      }
    }
  }
  .set-width {
    width: 100%;
    border-radius: 16px;
    margin-left: 10px;
  }
}

</style>
<style lang="scss">
.form {
  .input {
    .el-input__inner {
      height: 37px;
      line-height: 37px;
      color: #AAB4D2;
      border-radius: 4px;
      border: 1px solid #D0DFFB;
      padding: 5px 8px 5px 36px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/teachAnalysis/courseAnalysis.vue